export const environment = {
  production: true,
  environmentName: 'staging',
  apiUrl: '/api',
  appVersion: 'v3.4.0',
  sessionWarningSecondsBeforeExpiry: 30,
};
